module.exports = __webpack_public_path__ + "assets/switch.555bb9c7.svg";